module.exports = __webpack_public_path__ + "static/media/play-button.c956a6c4.svg";